import { Component, Input, OnInit } from '@angular/core';
import { IFilterStation, IStation } from 'src/app/core/interfaces';
import { DataService } from 'src/app/core/services/data.service';

@Component({
  selector: 'app-marker-info',
  templateUrl: './marker-info.component.html',
  styleUrls: ['./marker-info.component.scss']
})
export class MarkerInfoComponent implements OnInit {
  @Input()
  data: IStation;
  public filters: Array<IFilterStation> =[];
  constructor(private _dataService: DataService) {

  }
  ngOnInit() {
    const {attributes} = this.data;
    this.filters = attributes.map(idAttribute => {
      return  this._dataService.getAttribute(idAttribute);
    });

  }
}
